import * as React from "react";

import { PageProps } from "gatsby";

import Footer from "cms/blocks/Footer";
import Navigation from "cms/blocks/Navigation";
import Meta from "cms/components/Meta";
import Text from "cms/components/Text";
import Layout from "cms/layouts/Layout";

import { Container, Content, Description } from "./404.styles";

export interface NotFoundProps extends PageProps {
  data: {
    sanityNavigation: Queries.SanityNavigation;
    sanityFooter: Queries.SanityFooter;
  };
}

const NotFound: React.FC<NotFoundProps> = ({ data }) => (
  <Layout themeMode="light">
    <Navigation {...data.sanityNavigation} />
    <Meta
      title="Not found"
      description="The page you were looking for was not found"
      url="/404/"
    />
    <Container>
      <Content>
        <Text variant="H3" as="h3" textAlign="center" marginBottom="0.315rem">
          404
        </Text>
        <Description>Not found ¯\_(ツ)_/¯</Description>
      </Content>
    </Container>
    <Footer {...data.sanityFooter} />
  </Layout>
);

export default NotFound;
